import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './authService';

/**
 * PrivateRoute component
 * Protects routes that require authentication
 * Supports both children and Outlet patterns
 */
const PrivateRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // If children is provided, render them
  if (children) {
    return children;
  }

  // Otherwise render Outlet for nested routes
  return <Outlet />;
};

export default PrivateRoute;
